import { createRouter, createWebHistory } from 'vue-router'
import HomePage from "@/pages/HomePage/HomePage.vue";
import Yachts from "@/pages/Yachts/Yachts.vue";
import AboutUs from "@/pages/AboutUs/AboutUs.vue";
import YachtPage from "@/pages/YachtPage/YachtPage.vue";
import CharterGuide from "@/pages/CharterGuide/CharterGuide.vue";
import Destinations from "@/pages/Destinations/Destinations.vue";
import DestinationPage from "@/pages/DestinationPage/DestinationPage.vue";
import Inquiry from "@/pages/Inquiry/Inquiry.vue";
import Blog from "@/pages/Blog/Blog.vue";
import ArticlePage from "@/pages/ArticlePage/ArticlePage.vue";
import MultipleYachtsInquiry from "@/components/MultipleYachtsInquiry/MultipleYachtsInquiry.vue";
import Imprint from "@/pages/Imprint/Imprint.vue";


const routes = [
    { path: '/', name: 'HomePage', component: HomePage },
    { path: '/yachts', name: 'Yachts', component: Yachts },
    { path: '/aboutUs', name: 'AboutUs', component: AboutUs },
    { path: '/destinations', name: 'Destinations', component: Destinations },
    { path: '/guide', name: 'CharterGuide', component: CharterGuide },
    { path: '/inquiry', name: 'Inquiry', component: Inquiry },
    { path: '/yachtsInquiry', name: 'YachtsInquiry', component: MultipleYachtsInquiry },
    { path: '/magazine', name: 'Articles', component: Blog },
    { path: '/magazine/:slug', name: 'ArticlePage', component: ArticlePage },
    { path: '/imprint', name: 'Imprint', component: Imprint },

    {
        path: '/yachts/:slug',
        name: 'YachtPage',
        component: YachtPage,
    },
    {
        path: '/destinations/:slug',
        name: 'DestinationPage',
        component: DestinationPage,
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        // Scroll to anchor if hash is present
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            };
        }

        // Don't auto-scroll for this specific route
        if (to.path.startsWith('/destinations/')) {
            return false; // <-- let the page handle it manually
        }

        // Only scroll to top if the route name or path changed (not just query or params)
        if (to.name !== from.name || to.path !== from.path) {
            return { top: 0 };
        }

        // Same route, don't scroll
        return false;
    }

})

export default router;
